import $ from 'jquery';

// import SinglePageUpdown from './single-page-updown';

import jQueryEasing from '../vendors/jquery.easing.1.3.js';

import TweenMax from 'gsap';
import TweenLite from 'gsap';
import TimelineMax from 'gsap/TimelineMax';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

class HomeSlider {
	
	constructor(args) {

		if( $(".home-scroller").length < 1 ) {
			return false;
		}

		this.slider = $('.home-scroller');
		this.sliderInner = this.slider.find('.home-scroller__inner');
		this.sliderLength = this.slider.find('.home-scroller__item').length;
		this.bulletList = $(".bullet-list");
		this.isScrolling = false;

		// this.setIsScrolling();
		this.setIsPortfolioLoaded();
		this.setPortfolioInViewport();
		this.setSliderOptions();
		this.setSliderStyles();
		this.initBullets();

		setTimeout(() => {
			this.initSlider();
			this.autoPlaySlides();
		}, args.waitTime);
		
		// this.sliderEvents();
	}

	setIsScrolling() {
		var self = this;
		var t, l = (new Date()).getTime();

		$(window).scroll(function(){
			var now = (new Date()).getTime();

			if(now - l > 400){
				$(this).trigger('scrollStart');
				l = now;
			}

			clearTimeout(t);
			t = setTimeout(function(){
				$(window).trigger('scrollEnd');
			}, 300);
		});

		$(window).bind('scrollStart', function(){
			self.isScrolling = true;
		});

		$(window).bind('scrollEnd', function(){
			self.isScrolling = false;
		});
	}

	setIsPortfolioLoaded() {
		var hash = window.location.hash;
		if( hash ) {
			var urlHash = hash.substring(1);
			if('portfolio' == urlHash) {
				this.skipSlider();
			}
		}
	}

	setPortfolioInViewport() {
		var $window = $(window);
		var distance;
		this.isSliderSkipped = false;

		this.portfolioIsInViewport = false;
		var self = this;
		setTimeout(() => {
			distance = $('.bjzm-wrapper--home').offset().top; 
		},300)	

		$window.scroll(function() {
	       
			if ( $window.scrollTop() >= distance  && !self.portfolioIsInViewport ) {
		        self.portfolioIsInViewport = true;
		        self.isSliderSkipped = true;
		        self.skipSlider();
		    }
		});
	}

	skipSlider() {

		$(".home-scroller__item").addClass('scroller__item--active');
		// var y = (this.sliderLength - 1) * this.slideHeight * -1;
		// this.sliderInner.css("transform", `translate(0, ${y}px )`);
		$(".home-scroller").addClass('home-scroller--slider-skipped');
		$(".bullet").addClass('deactive').removeClass('active');
	}

	setSliderOptions() {
		// this.slideSpeed = 2200;	// original
		this.slideSpeed = 1200;	// flaster
		 // this.transitionDuration = 1.05;	//	original
		this.transitionDuration = 0.7;	//	faster
		//this.transitionDuration = 1;	//	slower
		this.timeoutDuration = 500;
		this.lastSlide = false;
		this.activeSlide = 0;
	}

	initBullets() {
		this.bulletList.find('bullet:first-child').addClass('active');
	}

	setSliderStyles() {
		this.slideHeight = $(window).outerHeight();
		var sliderInnerHeight = this.slideHeight;
		this.slider.height(this.slideHeight);
		this.sliderInner.height(sliderInnerHeight);
		this.slider.find('.home-scroller__list').height(sliderInnerHeight);
		this.slider.find('.home-scroller__item').css("transition-duration", `${this.transitionDuration}s`);
	}

	initSlider() {
		this.setSlideActive(0);
	}

	autoPlaySlides() {
	
		var interval = setInterval(() => {
			if(!this.isSliderSkipped) {
				this.activeSlide ++;
				if( this.activeSlide == (this.sliderLength - 1) ) {
					clearInterval(interval);
					this.lastSlide = true;

				}
				if( this.activeSlide != 0) {
					// this.moveSliderInner();
				}
				this.setSlideActive(this.activeSlide);
			}	
		}, this.slideSpeed);

	}

	moveSliderInner() {
		var y = this.activeSlide * this.slideHeight * -1;
		this.sliderInner.css("transform", `translate(0, ${y}px )`);
	}

	setSlideActive(index) {
		var $slide = this.slider.find(`.home-scroller__item--count-${index}`);
		if( this.activeSlide != 0) {
			$slide.addClass('home-scroller__item--active');
		}

		// this.beforeSlide($slide);
		
		var previousIndex = index - 1;
		var nextIndex = index + 1;

		if( !this.lastSlide )  {
			// this.afterSlide($slide);
			this.bulletList.find(`.bullet`).removeClass('active');
			this.bulletList.find(`.bullet[data-slide-index="${index}"]`).addClass('active');
		}
		else {
			this.bulletList.find(`.bullet`).removeClass('active');
			this.bulletList.find(`.bullet[data-slide-index="${index}"]`).addClass('active');
			this.bulletList.find(`.bullet[data-slide-index="${previousIndex}"]`).addClass('deactive');
			setTimeout(() => {
				this.bulletList.find(`.bullet`).removeClass('active');
				this.bulletList.find(`.bullet[data-slide-index="${index}"]`).addClass('last-line-deacativate');
			}, this.slideSpeed);
		}

		if( !this.lastSlide )  {
			if( this.bulletList.find(`.bullet[data-slide-index="${previousIndex}"]`).length > 0 ) {
				this.bulletList.find(`.bullet[data-slide-index="${previousIndex}"]`).addClass('deactive');
			}
		}

	}

	beforeSlide($slide) {
	
		var $content = $slide.find(".home-scroller__content");
		var $backgroundImage = $slide.find(".home-scroller__background-image");

		var yOffset = this.activeSlide == 0 ? 450 : 850;

		if( this.activeSlide != 0) {
			var startTop = ( this.slideHeight - yOffset ) * -1;
		}
		else {
			var startTop = 50;
		}
		
		setTimeout(() => {
			TweenLite.fromTo($content, this.transitionDuration  - .25, {opacity: 0, y: startTop, ease: 'none'}, {opacity: 1, y: 0, ease: 'none'});
		}, this.transitionDuration + 250);

		if( this.activeSlide != 0) {
			TweenLite.fromTo($backgroundImage, this.transitionDuration, {y: '-50%', ease: Power2.easeInOut}, {y: '-25%', ease: Power2.easeInOut});
		}

	}
	
	afterSlide($slide) {
		
		var $content = $slide.find(".home-scroller__content");
		var timeAfterDuration = this.slideSpeed - ( this.transitionDuration * 2 );
		var $backgroundImage = $slide.find(".home-scroller__background-image");

		var finishTop = (this.slideHeight / 2) + 100;

		setTimeout(() => {
			TweenLite.fromTo($content, this.transitionDuration, {opacity: 1, y: 0, ease: Power2.easeInOut}, {opacity: 0, y: finishTop, ease: Power2.easeInOut});
			TweenLite.fromTo($backgroundImage, this.transitionDuration, {y: '-25%', ease: Power2.easeInOut}, {y: '0%', ease: Power2.easeInOut});
		},this.slideSpeed);

	}

	sliderEvents() {
		$(".home-scroller__list").on('click', () => {
			var $slide = this.slider.find(`.home-scroller__item--count-1`);
			var $backgroundImage = $slide.find(".home-scroller__background-image");
			TweenLite.fromTo($backgroundImage, this.transitionDuration, {y: '-50%', ease: 'none'}, {y: '-25%', ease: 'none'});
		});
	}

}
module.exports = HomeSlider;
















